import classNames from 'classnames';

import useLandingPropsStore from 'stores/landingPropsStore';
import { ThumbnailsProps } from './types';

import useStyles from './styles';

const countPerDevice = {
  desktop: 4,
  tablet: 2,
  phone: 1,
};

const ThumbnailsUrlWithHeaderAndDescriptionFallback = ({
  description,
  title,
  items,
}: ThumbnailsProps) => {
  const styles = useStyles();
  const device = useLandingPropsStore(x => x.device);
  return (
    <div className={styles.root}>
      {title && (
        <div className={classNames(styles.title, styles.titleFallback)}>
          <i className="skeleton" />
        </div>
      )}
      {description && (
        <div className={styles.descriptionWrapper}>
          <div className={classNames(styles.description, styles.descriptionFallback)}>
            <i className="skeleton" />
          </div>
          <div className={classNames(styles.description, styles.descriptionFallback)}>
            <i className="skeleton" />
          </div>
        </div>
      )}
      <div className={styles.gridContainer}>
        {items?.slice(0, countPerDevice[device]).map(({ title: key }, index) => (
          <div key={`ThumbnailsUrlWi-${key}-${index}`} className={styles.gridItem}>
            <div className={styles.gridItemFallback}>
              <i className="skeleton" />
            </div>
            <div className={styles.contentTitleFallback}>
              <i className="skeleton" />
            </div>
            <div className={styles.contentBtnFallback}>
              <i className="skeleton" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThumbnailsUrlWithHeaderAndDescriptionFallback;
